import { ComputerAgentDataStatus, MessageRole, ToolCallStatus } from "../types";
import { ChatMessage } from "../stores/types";

export const findLastByRole = (messages: ChatMessage[], role: MessageRole): number => {
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i]?.role === role) {
      return i;
    }
  }
  return -1;
};

export const findToolCallToUpdate = (messages: ChatMessage[], toolCallId?: string): number => {
  let targetIdx = -1;
  let firstRunningIdx = -1;

  for (let i = messages.length - 1; i >= 0; i--) {
    const msg = messages[i];
    if (msg?.role === MessageRole.TOOL_CALL && msg.toolCall) {
      if (msg.toolCall.status === ToolCallStatus.RUNNING && firstRunningIdx === -1) {
        firstRunningIdx = i;
      }
      if (toolCallId && msg.toolCall.id === toolCallId) {
        targetIdx = i;
        break;
      }
    }
  }

  return targetIdx !== -1 ? targetIdx : firstRunningIdx;
};

export const findComputerAgentMessageIndex = (messages: ChatMessage[]): number => {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i];
    if (
      message?.role === MessageRole.COMPUTER_AGENT &&
      message.computerAgent?.status !== ComputerAgentDataStatus.COMPLETED &&
      message.computerAgent?.status !== ComputerAgentDataStatus.ERROR
    ) {
      return i;
    }
  }
  return -1;
};

export const findLastAssistantMessageIndex = (messages: ChatMessage[]): number => {
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i]?.role === MessageRole.ASSISTANT) {
      return i;
    }
  }
  return -1;
};

export const findTargetMessageIndex = (
  messages: ChatMessage[],
  messageRole: MessageRole.MASTER_VIBE_PROMPT | MessageRole.ASSISTANT,
  assistantMessageIndex: number,
): number => {
  if (messageRole === MessageRole.ASSISTANT && assistantMessageIndex < 0) {
    return -1;
  }

  if (
    messageRole === MessageRole.ASSISTANT &&
    assistantMessageIndex >= 0 &&
    assistantMessageIndex < messages.length &&
    messages[assistantMessageIndex]?.role === MessageRole.ASSISTANT
  ) {
    return assistantMessageIndex;
  }

  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i]?.role === messageRole && i >= assistantMessageIndex) {
      return i;
    }
  }
  return -1;
};

export const hasEmptyAssistantMessage = (
  messages: ChatMessage[],
  assistantMessageIndex: number,
): boolean =>
  assistantMessageIndex >= 0 &&
  assistantMessageIndex < messages.length &&
  messages[assistantMessageIndex]?.role === MessageRole.ASSISTANT &&
  (!messages[assistantMessageIndex].content ||
    messages[assistantMessageIndex].content.trim() === "");

export const shouldCompleteToolCallsAfterEvent = (eventType: string): boolean =>
  [
    "delta",
    "tool_result",
    "tool_output",
    "tool_error",
    "done",
    "computer_agent_start",
    "computer_agent_progress",
    "computer_agent_complete",
    "computer_agent_error",
  ].includes(eventType);
